import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Forgot from './pages/Forgot';
import SetPassword from './pages/SetPassword';
import PublicProduction from './pages/PublicProduction';
import Users from './pages/Users';
import Leads from './pages/Leads';
import LeadDetail from './pages/LeadDetail';
import Signature from './pages/Signature';
import QuickQuote from './pages/QuickQuote'; // @@QUICKQUOTE_ROUTE_v75@@
import ShopifyTax from './pages/ShopifyTax'; // @@SHOPIFY_TAX_REPORT_v71@@
import Vendors from './pages/Vendors';
import VendorDetail from './pages/VendorDetail';
import PurchaseOrders from './pages/PurchaseOrders';
import PurchaseOrderDetail from './pages/PurchaseOrderDetail';
import Production from './pages/Production';
import ProductionJobDetail from './pages/ProductionJobDetail';
import Tasks from './pages/Tasks';
import TaskDetail from './pages/TaskDetail';
import TaskList from './pages/TaskList'; // @@TASK_LISTS_v100@@
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Contacts from './pages/Contacts';
import Packages from './pages/Packages';
import PackageDetail from './pages/PackageDetail';
import TimeClock from './pages/TimeClock';
import Settings from './pages/Settings';
import Ship from './pages/Ship'; // @@SHIP_SECTION_v81@@
import Website from './pages/Website'; // @@SITE_v85@@
import Hiring from './pages/Hiring'; // @@JOBS_v86@@
import HiringApplicant from './pages/HiringApplicant'; // @@JOBS_v86@@
import HiringPosting from './pages/HiringPosting'; // @@JOBS_v86@@
import Equipment from './pages/Equipment'; // @@EQUIPMENT_LEASES_v87@@
import EquipmentLease from './pages/EquipmentLease'; // @@EQUIPMENT_LEASES_v87@@
import EquipmentUnit from './pages/EquipmentUnit'; // @@EQUIPMENT_LEASES_v87@@
import RoleHome from './components/RoleHome'; // @@CLIENT_PORTAL_v1@@
import ClientPortal from './pages/ClientPortal'; // @@CLIENT_PORTAL_v1@@
import TechPacks from './pages/TechPacks'; // @@TECH_PACKS_v94@@
import TechPackDetail from './pages/TechPackDetail'; // @@TECH_PACKS_v94@@
import PublicTechPack from './pages/PublicTechPack'; // @@TECH_PACKS_v94@@
import Quotes from './pages/Quotes'; // @@QUOTES_READY_v106@@
import Receipts from './pages/Receipts'; // @@RECEIPTS_v107@@
import CarrierBills from './pages/CarrierBills'; // @@CARRIER_BILLS_v119@@
import Collections from './pages/Collections'; // @@COLLECTIONS_v123@@

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot" element={<Forgot />} />
          <Route path="/accept" element={<SetPassword />} />
          <Route path="/reset" element={<SetPassword />} />
          <Route path="/public/vendor/:token" element={<PublicProduction />} />
          <Route path="/public/techpack/:token" element={<PublicTechPack />} /> {/* @@TECH_PACKS_v94@@ anonymous share link */}
          {/* @@CLIENT_PORTAL_v1@@ "/" resolves by role: client -> /portal, else dashboard */}
          <Route path="/" element={
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user', 'client']}>
              <RoleHome />
            </PrivateRoute>
          } />
          {/* @@CLIENT_PORTAL_v1@@ client portal (client role only) */}
          <Route path="/portal" element={
            <PrivateRoute roles={['client']}>
              <ClientPortal />
            </PrivateRoute>
          } />
          <Route path="/leads" element={
            <PrivateRoute roles={['admin', 'manager']}>
              <Layout><Leads /></Layout>
            </PrivateRoute>
          } />
          <Route path="/leads/:id" element={
            <PrivateRoute roles={['admin', 'manager']}>
              <Layout><LeadDetail /></Layout>
            </PrivateRoute>
          } />
          <Route path="/tasks" element={
            <PrivateRoute roles={['admin', 'manager', 'staff']}>
              <Layout><Tasks /></Layout>
            </PrivateRoute>
          } />
          <Route path="/tasks/lists/:listId" element={
            <PrivateRoute roles={['admin', 'manager', 'staff']}>
              <Layout><TaskList /></Layout>
            </PrivateRoute>
          } />
          <Route path="/tasks/:id" element={
            <PrivateRoute roles={['admin', 'manager', 'staff']}>
              <Layout><TaskDetail /></Layout>
            </PrivateRoute>
          } />
          <Route path="/signature" element={
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user']}>
              <Layout><Signature /></Layout>
            </PrivateRoute>
          } />
          <Route path="/quick-quote" element={
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user']}>
              <Layout><QuickQuote /></Layout>
            </PrivateRoute>
          } />
          <Route path="/clients" element={
            <PrivateRoute roles={['admin', 'manager', 'staff']}>
              <Layout><Clients /></Layout>
            </PrivateRoute>
          } />
          <Route path="/clients/:id" element={
            <PrivateRoute roles={['admin', 'manager', 'staff']}>
              <Layout><ClientDetail /></Layout>
            </PrivateRoute>
          } />
          <Route path="/contacts" element={
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user']}>
              <Layout><Contacts /></Layout>
            </PrivateRoute>
          } />
          <Route path="/packages" element={
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user']}>
              <Layout><Packages /></Layout>
            </PrivateRoute>
          } />
          <Route path="/packages/:id" element={
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user']}>
              <Layout><PackageDetail /></Layout>
            </PrivateRoute>
          } />
          <Route path="/ship" element={ /* @@SHIP_SECTION_v81@@ */
            <PrivateRoute roles={['admin', 'manager']}>
              <Layout><Ship /></Layout>
            </PrivateRoute>
          } />
          <Route path="/website" element={ /* @@SITE_v85@@ */
            <PrivateRoute roles={['admin', 'manager']}>
              <Layout><Website /></Layout>
            </PrivateRoute>
          } />
          <Route path="/hiring" element={ /* @@JOBS_v86@@ */
            <PrivateRoute roles={['admin', 'manager']}>
              <Layout><Hiring /></Layout>
            </PrivateRoute>
          } />
          <Route path="/hiring/applicants/:id" element={ /* @@JOBS_v86@@ */
            <PrivateRoute roles={['admin', 'manager']}>
              <Layout><HiringApplicant /></Layout>
            </PrivateRoute>
          } />
          <Route path="/hiring/postings/:id" element={ /* @@JOBS_v86@@ */
            <PrivateRoute roles={['admin', 'manager']}>
              <Layout><HiringPosting /></Layout>
            </PrivateRoute>
          } />
          <Route path="/equipment" element={ /* @@EQUIPMENT_LEASES_v87@@ */
            <PrivateRoute roles={['admin', 'manager', 'staff']}>
              <Layout><Equipment /></Layout>
            </PrivateRoute>
          } />
          <Route path="/equipment/leases/:id" element={ /* @@EQUIPMENT_LEASES_v87@@ */
            <PrivateRoute roles={['admin', 'manager', 'staff']}>
              <Layout><EquipmentLease /></Layout>
            </PrivateRoute>
          } />
          <Route path="/equipment/units/:id" element={ /* @@EQUIPMENT_LEASES_v87@@ */
            <PrivateRoute roles={['admin', 'manager', 'staff']}>
              <Layout><EquipmentUnit /></Layout>
            </PrivateRoute>
          } />
          <Route path="/tech-packs" element={ /* @@TECH_PACKS_v94@@ */
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user']}>
              <Layout><TechPacks /></Layout>
            </PrivateRoute>
          } />
          <Route path="/tech-packs/:id" element={ /* @@TECH_PACKS_v94@@ */
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user']}>
              <Layout><TechPackDetail /></Layout>
            </PrivateRoute>
          } />
          <Route path="/timeclock" element={
            <PrivateRoute roles={['admin', 'manager']}>
              <Layout><TimeClock /></Layout>
            </PrivateRoute>
          } />
          <Route path="/vendors" element={
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user']}>
              <Layout><Vendors /></Layout>
            </PrivateRoute>
          } />
          <Route path="/vendors/:id" element={
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user']}>
              <Layout><VendorDetail /></Layout>
            </PrivateRoute>
          } />
          <Route path="/purchase-orders" element={
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user']}>
              <Layout><PurchaseOrders /></Layout>
            </PrivateRoute>
          } />
          <Route path="/purchase-orders/:id" element={
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user']}>
              <Layout><PurchaseOrderDetail /></Layout>
            </PrivateRoute>
          } />
          <Route path="/production" element={
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user']}>
              <Layout><Production /></Layout>
            </PrivateRoute>
          } />
          <Route path="/production/:id" element={
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user']}>
              <Layout><ProductionJobDetail /></Layout>
            </PrivateRoute>
          } />
          <Route path="/quotes" element={ /* @@QUOTES_READY_v106@@ */
            <PrivateRoute roles={['admin', 'manager']}>
              <Layout><Quotes /></Layout>
            </PrivateRoute>
          } />
          <Route path="/receipts" element={ /* @@RECEIPTS_v107@@ */
            <PrivateRoute roles={['admin', 'manager', 'staff', 'user']}>
              <Layout><Receipts /></Layout>
            </PrivateRoute>
          } />
          <Route path="/collections" element={ /* @@COLLECTIONS_v123@@ */
            <PrivateRoute roles={['admin', 'manager']}>
              <Layout><Collections /></Layout>
            </PrivateRoute>
          } />
          <Route path="/carrier-bills" element={ /* @@CARRIER_BILLS_v119@@ */
            <PrivateRoute roles={['admin', 'manager']}>
              <Layout><CarrierBills /></Layout>
            </PrivateRoute>
          } />
          <Route path="/settings" element={
            <PrivateRoute roles={['admin', 'manager']}>
              <Layout><Settings /></Layout>
            </PrivateRoute>
          } />
          {/* @@SHOPIFY_TAX_REPORT_v71@@ */}
          <Route path="/shopify-tax" element={
            <PrivateRoute roles={['admin', 'manager', 'staff']}>
              <Layout><ShopifyTax /></Layout>
            </PrivateRoute>
          } />
          <Route path="/users" element={
            <PrivateRoute roles={['admin']}>
              <Layout><Users /></Layout>
            </PrivateRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
